import React from "react";
export default function MapComponent({ map }) {

  return (
    <>
      {map.iframeCode ? (
        <div
          style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}
          dangerouslySetInnerHTML={{ __html: map.iframeCode }}
        />
      ) : (
        <h2 style={{ textAlign: "center" }}>Loading map...</h2>
      )}
    </>
  );
}
